import React from 'react';

export const TextStyle = () => (
    <g>
        <path d='M4,16h1.494c0.001,0,0.003,0,0.005,0H7c0.276,0,0.5-0.224,0.5-0.5S7.276,15,7,15H6.262l1.733-4h8.01l1.733,4H17
        c-0.276,0-0.5,0.224-0.5,0.5S16.724,16,17,16h3c0.276,0,0.5-0.224,0.5-0.5S20.276,15,20,15h-1.171l-6.37-14.699
        c-0.158-0.365-0.76-0.365-0.918,0L5.171,15H4c-0.276,0-0.5,0.224-0.5,0.5S3.724,16,4,16z M12,1.758L15.571,10H8.429L12,1.758z' />
        <path d='M23.5,18h-23C0.224,18,0,18.224,0,18.5v5C0,23.776,0.224,24,0.5,24h23c0.276,0,0.5-0.224,0.5-0.5v-5
        C24,18.224,23.776,18,23.5,18z M23,23H1v-4h22V23z' />
        <path d='M19.646,21.854C19.744,21.951,19.872,22,20,22s0.256-0.049,0.354-0.146l1-1c0.143-0.143,0.186-0.358,0.108-0.545
        S21.202,20,21,20h-2c-0.202,0-0.385,0.122-0.462,0.309s-0.034,0.402,0.108,0.545L19.646,21.854z' />
    </g>
);